angular.module("Main").controller("AggregatorStep2Controller", ["$rootScope", "$scope", "$state", "$localStorage", "$uibModal", "$window", "$stateParams", "$location", "$translate", "DialogService", "ShopService", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $localStorage, $uibModal, $window, $stateParams, $location, $translate, DialogService, ShopService, PaymentService, BookingService, SessionService) {
        var vm = this;

        if (!_.isEmpty($stateParams.club)) {
            vm.withoutClubsMenuItem = true;
            vm.mandantNr = $stateParams.club;
            loadAggregatorenConfig();
        } else {
            vm.withoutClubsMenuItem = false;
            vm.cookies = SessionService.checkSession();
            if (!_.isNil(vm.cookies.aggregatorClubData)) {
                vm.clubData = vm.cookies.aggregatorClubData;
                vm.aggregatorData = vm.cookies.aggregatorData;
                vm.mandantNr = vm.clubData.selectedMandantNr;
                vm.mandatBezeichnung = vm.clubData.selectedMandantName;
                loadAggregatorenConfig();
            }
        }

        function loadAggregatorenConfig() {
            vm.mandant = {MandantNr: vm.mandantNr, MandantBezeichnung: vm.mandatBezeichnung};
            BookingService.loadRegisterText(vm.mandant, vm.aggregatorData).then(function (data) {
                vm.aggregatorenConfigtext = data;
            })
        }


        vm.accepted = false;
        vm.openedMenuBar = false;
        vm.errorRegisterDialog = false;

        vm.regexBic = '([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)'
        vm.regexStreetAndNumber = '^(([a-zA-ZäöüÄÖÜ]\\D*)\\s+\\d+?\\s*.*)$';
        vm.isDeIban = false;
        vm.memberZip = true;

        vm.errorNotFound = false;
        vm.errorFound = false;
        vm.globalError = false;

        vm.checkIban = function () {
            if (!_.isUndefined(vm.member.iban))
                return BookingService.isIbanValid(vm.member.iban).then(
                    function (valid) {
                        if (_.isUndefined(valid.isValid)) {
                            if (!valid) {
                                vm.memberIban = false
                                vm.isDEIban = false;
                            } else {
                                vm.memberIban = true
                                vm.isDEIban = true;
                            }

                        } else {
                            if (valid.isValid && valid.isDE) {
                                vm.memberIban = true
                                vm.isDEIban = true;

                            }

                            if (valid.isValid && !valid.isDE) {
                                vm.memberIban = true
                                vm.isDEIban = false;
                            }
                            if (!valid.isValid) {
                                vm.memberIban = false
                                vm.isDEIban = false;
                            }
                        }

                    }
                )

        }

        vm.errorRequiredSignature = false;
        let abschliessen = false;
        vm.spinner = false;
        vm.showFormular = true;

        if (!SessionService.getSessionId()) {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
        } else
            start();

        function start() {
            vm.cookies = SessionService.checkSession();
            if (vm.cookies.aggregatorMemberData) {
                vm.member = vm.cookies.aggregatorMemberData.Member;
            }
            init();
        }

        loadConfigs();
        getKursbuchungLayouKonfiguration();
        loadOnlineSalesFarbenConfiguration();
        loadRegisterRequired();


        function loadRegisterRequired() {
            BookingService.loadRegisterReq().then(function (data) {
                vm.registrationRequiredFields = data;
            })
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        $('#register-focus').autofocus;


        function init() {
            if (_.isNil(vm.cookies.aggregatorData) || _.isNil(vm.cookies.aggregatorData)) {
                if (!_.isEmpty($stateParams.club)) {
                    $state.go('aggregator_clubs', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
                } else {
                    $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
                }
            }
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
            });
        }

        function loadOnlineSalesFarbenConfiguration() {
            BookingService.getOnlineSalesLayout().then(function (data) {
                vm.layoutColors = angular.fromJson(data.Layout_Colors);
            })
        }

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.goToAngebot = function () {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
            vm.openedMenuBar = false;
        };

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };

        vm.showChangedMemberData = function () {
            vm.memberValuesHasChangedChecked = true;
        };

        vm.checkChangedMemberData = function (memberFormValid) {
            vm.memberFormValid = memberFormValid;
            vm.changedMemberValues = [];
            if (vm.member.Vorname !== vm.member.firstname) {
                vm.changedMemberValues.push("Vorname")
            }
            if (vm.member.Nachname !== vm.member.lastname) {
                vm.changedMemberValues.push("Nachname")
            }
            if (vm.member.Email !== vm.member.email) {
                vm.changedMemberValues.push("Email")
            }
            if (!(_.isUndefined(vm.member.Geburtsdatum) && vm.member.birthday === null)) {
                if (!_.isEqual(new Date(vm.member.Geburtsdatum), new Date(vm.member.birthday))) {
                    vm.changedMemberValues.push("Geburtsdatum")
                }
            }
            if (vm.member.Mobil !== vm.member.mobile && !(_.isUndefined(vm.member.Mobil) && vm.member.mobile === '')) {
                vm.changedMemberValues.push("Mobil")
            }
            if (vm.member.StrasseNr !== vm.member.street && !(_.isUndefined(vm.member.StrasseNr) && (vm.member.street === ''))) {
                vm.changedMemberValues.push("StrasseHNr")
            }
            if (vm.member.Plz !== vm.member.zipcode && !(vm.member.Plz !== '' && !_.isUndefined(vm.member.Plz) && (vm.member.zipcode !== ''))) {
                vm.changedMemberValues.push("PLZ")
            }
            if (vm.member.Stadt !== vm.member.city) {
                vm.changedMemberValues.push("Ort")
            }
            if (vm.member.Iban !== vm.member.iban) {
                vm.changedMemberValues.push("Iban")
            }
            if (vm.member.Bic !== vm.member.bic && !_.isUndefined(vm.member.bic)) {
                vm.changedMemberValues.push("Bic")
            }
            if (!_.isUndefined(vm.member.accountOwnerfirstname) && !_.isUndefined(vm.member.accountOwnerlastname)) {

                if (vm.member.Kontoinhaber !== vm.member.accountOwnerfirstname + ' ' + vm.member.accountOwnerlastname) {
                    vm.changedMemberValues.push("Kontoinhaber")
                }
            }
        };

        vm.startCodeStep = function (valid) {
            if (valid) {
                SessionService.setMemberData(vm.member);
                $state.go('aggregator_code', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
            }
        }

        vm.goBack = function () {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
        }

        vm.cancel = function () {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
        }

    }]);